<span *ngIf="caption" class="sq-text">{{caption | sqMessage}}</span>
<sq-labels [record]="record" [public]="public"></sq-labels>
